import Vue from "vue";
import VueRouter from "vue-router";
import Login from "../views/Login.vue";
import OldLogin from "../views/OldLogin.vue";
// import firebase from "firebase/app";
import authGuard from "../authGuard";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Landing.vue"),
    meta: { requiresAuth: false }
  },
  {
    path: "/home",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Home.vue"),
    meta: { requiresAuth: false },
    beforeEnter: authGuard
  },
  {
    path: "sources/:id/posts",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Posts.vue"),
    meta: { requiresAuth: false },
    beforeEnter: authGuard
  },
  {
    path: "/dashboard",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Dashboard.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/login",
    name: "Login",
    component: Login
  },
  {
    path: "/oldlogin",
    name: "OldLogin",
    component: OldLogin
  },
  {
    path: "/callback",
    name: "Callback",
    component: OldLogin
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
